<template>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <!--div class="vx-col lg:block lg:w-1/2">
              <img src="@/assets/images/logo/logo-Mapgrafi.png" alt="login" class="mx-auto">
            </div-->

            <div class="vx-col sm:w-full md:w-full lg:w-2/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <!--div class="vx-card__title mb-4">
                  <h4 class="mb-4">Iniciar Sesión</h4>
                </div-->

                <vs-tabs>
                    <vs-tab label="Iniciar Sesión">
                        <login-jwt></login-jwt>
                    </vs-tab>
                </vs-tabs>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
</template>


<script>
import LoginJwt from "./loginTypes/LoginJWT.vue"

export default {
  components: {
    LoginJwt,
  },
  methods:{
        validatorOnline(){
            if(this.$store.state.AppActiveUser.status)
            this.$router.push('/');
        }
  },
  created(){
    this.validatorOnline();
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
